import type { CurrencyPreference } from "./currency"
import type { Locale } from "./i18n"
import { locales } from "./i18n"
import { PERSONAS, type Persona } from "./persona"

const REGEX = new RegExp(
  `^/?(?:(?<locale>${locales.join("|")})(?=/|$))?/?(?:(?<currency>crypto|usd)(?=/|$))?/?(?:(?<persona>${Object.values(
    PERSONAS,
  ).join("|")})(?=/|$))?/?(?<rest>.*)?`,
)

type PathnameExtract = {
  locale?: Locale
  persona?: Persona
  currency?: CurrencyPreference
  rest: string
}

export function pathnameExtract(pathname: string): PathnameExtract {
  const {
    locale,
    persona,
    rest = "",
    currency,
  } = REGEX.exec(pathname)?.groups ?? {}

  return {
    locale: locale as Locale | undefined,
    persona: persona as Persona | undefined,
    rest: `/${rest}`,
    currency: currency as CurrencyPreference | undefined,
  }
}
